module.exports = __webpack_public_path__ + "assets/37b82b21b37712a83a4c867cf6d60bb6.icon_thumbs_up.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./app/src/styles/images/icon_thumbs_up.svg
 ** module id = 835
 ** module chunks = 1
 **/